module.exports = __webpack_public_path__ + "img/datos_domicilio.8055e086.svg";